export default __webpack_public_path__ + "static/media/LegoEducation.58c4e67f.png";